import React from 'react';
import { Navbar, Nav, Button, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const NavbarComponent = ({ handleAddItem, companies }) => {
  const renderSellButton = handleAddItem && (
    <Button variant="dark" onClick={handleAddItem}>
      Sell with us
    </Button>
  );

  const renderCompaniesDropdown = companies && companies.length > 0 && (
    <NavDropdown title="Companies" id="companies-dropdown">
      {companies.map((company) => (
        <NavDropdown.Item key={company} as={Link} to={`/${company}`}>
          {company}
        </NavDropdown.Item>
      ))}
    </NavDropdown>
  );

  return (
    <Navbar bg="light" expand="lg" className="justify-content-between">
      <Navbar.Brand as={Link} to="/" className="font-lora">
        BAKAARO
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-auto">
          <Nav.Link as={Link} to="/">
            Home
          </Nav.Link>
          {renderCompaniesDropdown}
          <Nav.Link href="#about">About</Nav.Link>
          <Nav.Link href="#contact">Contact</Nav.Link>
        </Nav>
        {renderSellButton}
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavbarComponent;
